<div *ngIf="shouldShowNotification">
  <div class="notification notification-warning text--input-small">
    <mat-icon>info</mat-icon>
    <div>{{ 'cart.cart-notification-delivery-date-weekend' | translate }}</div>
  </div>
</div>
